import React, { useEffect, useState } from "react";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { useNavigate } from "react-router-dom";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import ToastManager from "../../Components/ToastManager";
import OptinFollowUpTable from "./OptinFollowUpTable";

const OptinFollowUp = () => {
  let pageId: string = "";
  let pageName: any = null;
  let fbAccountId: any = null;

  const [optinTemplateList, setOptinTemplateList] = useState([]);

  //   useEffect(() => {
  //     const fbPageInfo: any = localStorage.getItem("fbPageDetail");
  //     const recFbPageInfp = JSON.parse(fbPageInfo)?.facebook;

  //     pageId = recFbPageInfp?.fbPageId;
  //     pageName = recFbPageInfp?.pageName;
  //     fbAccountId = recFbPageInfp?.fbAccountId;
  //     if (pageId) {
  //       let pageDataReq = "pageId=" + pageId;
  //       try {
  //         NetworkManager.sendJsonRequest(
  //           "getOptinTemplatesbyPageId",
  //           "",
  //           pageDataReq,
  //           "GET",
  //           true,
  //           onSuccessGetList,
  //           onErrorCall
  //         );
  //       } catch (error) {}
  //       savePageIdAndName(pageId, pageName, fbAccountId);
  //     }
  //   }, []);

  const onSuccessGetList = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      if (respData.statusCode === "Template2000") {
        const optinTemplateList = respData.optinTemplateDetailsList;
        setOptinTemplateList(optinTemplateList);
      } else if (respData.statusCode === "Template1105") {
        ToastManager.showToast("No Optin templates for the pageId", "Error");
      }
    }
  };
  const onErrorCall = (err: any) => {
    console.log(err);
  };

  const {
    sideBar,
    optinFollow,
    setOptinFollow,
    setMenuTab,
    saveNewNodeAndEdges,
    saveTemplateName,
  } = useProductsContext();

  const navigate = useNavigate();

  const handleMenu = () => {
    setOptinFollow("optin");
    setMenuTab("chatbot1");
    navigate(`/dashboard/chatbot`, { state: { create: false, from: "fb" } });
    saveNewNodeAndEdges([], []);
    saveTemplateName({});
  };

  return (
    <>
      <div
        className="content-page"
        style={{
          marginLeft: sideBar ? "230px" : "120px",
          backgroundColor: "#fff",
        }}>
        <div className="content">
          <div className="container-fluid">
            <div className="row"></div>
            <div className="sec-wrapper">
              <div className="d-flex align-items-center justify-content-between mb-3 mt-2">
                <h5 className="page-title">Opt-In Follow Up Templates</h5>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={handleMenu}
                    className="btn btn-primary rounded-pill new-chat">
                    <img
                      src="../assets/images/chatbot.svg"
                      className="img-fluid"
                      alt=""
                    />
                    New Opt-in Follow Up Template
                  </button>
                </div>
              </div>
              <div className="tablerounededCorner-subscriber table-responsive">
                <OptinFollowUpTable rows={optinTemplateList} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OptinFollowUp;
